import styled from "@emotion/styled"
import Group from "./Group"
import { css } from "@emotion/react"

const ButtonGroup = styled(Group)<{ borderLess?: boolean }>`
  & > *:first-child:not(:only-child) {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  & > *:last-child:not(:only-child) {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;

    ${(p) =>
      p.borderLess &&
      css`
        border-left: none;
      `}
  }
  &:has(:not(:only-child)) {
    gap: 1px;

    ${(p) =>
      p.borderLess &&
      css`
        gap: 0;
      `}
  }
`

export default ButtonGroup
